const storageKey = "solufy-login-retry-at";

export function mountAuthCooldown(root) {
	const forms = [...root.querySelectorAll('.solufy-auth-page-wrapper .form-login')];
	if (!forms.length || !window.login?.login_handlers) return;
	let retryAt = 0;
	let timer;
	try { retryAt = Number(sessionStorage.getItem(storageKey)) || 0; } catch {}
	const controls = forms.map(form => {
		const button = form.querySelector('button[type="submit"]');
		const notice = document.createElement('p');
		notice.className = 'solufy-auth-cooldown';
		notice.setAttribute('role', 'status');
		notice.hidden = true;
		const message = document.createElement('span');
		message.textContent = 'Too many unsuccessful sign-in attempts. Please wait ';
		const clock = document.createElement('span');
		clock.setAttribute('aria-live', 'off');
		notice.append(message, clock, document.createTextNode(' before trying again.'));
		form.querySelector('.page-card-body').prepend(notice);
		form.addEventListener('submit', event => {
			if (retryAt > Date.now()) {
				event.preventDefault();
				event.stopImmediatePropagation();
				render();
			}
		}, true);
		return {form, button, notice, clock, label: button.textContent.trim()};
	});

	function render() {
		const remaining = Math.max(0, Math.ceil((retryAt - Date.now()) / 1000));
		controls.forEach(({form, button, notice, clock, label}) => {
			button.disabled = remaining > 0;
			notice.hidden = !remaining;
			if (remaining) {
				const minutes = Math.floor(remaining / 60);
				const seconds = String(remaining % 60).padStart(2, '0');
				clock.textContent = `${minutes}:${seconds}`;
				button.removeAttribute('aria-busy');
				button.textContent = `Try again in ${minutes}:${seconds}`;
				form.querySelector('.login-error-banner')?.classList.add('hidden');
			} else if (retryAt) {
				button.textContent = label;
			}
		});
		if (!remaining) {
			retryAt = 0;
			clearInterval(timer);
			try { sessionStorage.removeItem(storageKey); } catch {}
		}
	}

	function start(seconds) {
		retryAt = Date.now() + seconds * 1000;
		try { sessionStorage.setItem(storageKey, String(retryAt)); } catch {}
		clearInterval(timer);
		render();
		timer = setInterval(render, 250);
	}

	[401, 403, 417, 429, 500].forEach(status => {
		const original = window.login.login_handlers[status];
		window.login.login_handlers[status] = function (xhr, ...args) {
			original?.call(this, xhr, ...args);
			const header = xhr.getResponseHeader('Retry-After');
			const seconds = /^\d+$/.test(header || '')
				? Number(header) : Math.ceil((Date.parse(header) - Date.now()) / 1000);
			if (Number.isFinite(seconds) && seconds > 0) start(seconds);
		};
	});
	if (retryAt > Date.now()) start((retryAt - Date.now()) / 1000);
	else render();
}
